import * as React from 'react'
import { useOutletContext } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import PermissionGroups from 'modules/permissions/components/Permissions'
import NewGroup from 'modules/permissions/components/Permissions/NewGroup'

import { PermissionsContainerContext } from './PermissionsRootPage'

const PermissionsSettingsPage = () => {
  const { loading } = useOutletContext<PermissionsContainerContext>()
  const [isModalOpen, setIsModalOpen] = React.useState(false)

  function onClick() {
    setIsModalOpen(!isModalOpen)
  }

  function onClose() {
    setIsModalOpen(false)
  }

  return (
    <ResponsivePage.Body
      loading={loading}
      error={null}
      widget={
        <Button type="primary" onClick={onClick}>
          {i18n.t('settings.permissions.create_group')}
        </Button>
      }
    >
      <PermissionGroups />
      {isModalOpen && <NewGroup onClose={onClose} />}
    </ResponsivePage.Body>
  )
}

export default PermissionsSettingsPage
